import React from 'react'
import { StatCards } from '@/shared/ui/StatCards'
import { BarChart3, BadgeCheck, ShieldAlert, Target, TrendingUp } from 'lucide-react'
import type { RelatorioV2Metrics } from '../utils/metrics'
import { formatInt, formatPct01 } from '../utils/format'

export default function OutcomeSummaryCards({ metrics }: { metrics: RelatorioV2Metrics }) {
  return (
    <StatCards
      items={[
        {
          label: 'Total de trades (encerradas por Sinais)',
          value: formatInt(metrics.total),
          icon: <BarChart3 className="h-5 w-5" />,
          tone: 'primary',
        },
        {
          label: `Atingiu Alvo 3 ƒ?½ ${formatPct01(metrics.tp3Hit / Math.max(1, metrics.total))}`,
          value: formatInt(metrics.tp3Hit),
          icon: <Target className="h-5 w-5" />,
          tone: 'success',
        },
        {
          label: `Atingiu Alvo 2 ƒ?½ ${formatPct01(metrics.tp2Hit / Math.max(1, metrics.total))}`,
          value: formatInt(metrics.tp2Hit),
          icon: <BadgeCheck className="h-5 w-5" />,
          tone: 'success',
        },
        {
          label: `Atingiu Alvo 1 ƒ?½ ${formatPct01(metrics.winPct)}`,
          value: formatInt(metrics.tp1Hit),
          icon: <TrendingUp className="h-5 w-5" />,
          tone: 'success',
        },
        {
          label: `Stop (sem alvo) ƒ?½ ${formatPct01(metrics.stopPct)}`,
          value: formatInt(metrics.stopOnly),
          icon: <ShieldAlert className="h-5 w-5" />,
          tone: 'warning',
        },
      ]}
    />
  )
}

